function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { forwardRef, useState } from 'react';
import Text from "../Typography/Text";
import colors from "../../colors/index";
import { CheckBoxContainer, CheckboxLabel, CheckboxIcon, CheckboxInput } from "./styled";
import CheckIcon from "../Icon/CheckIcon";
export var CHECK_BOX_TEST_ID = 'CHECK_BOX_TEST_ID';
var CHECK_BOX_INPUT_TEST_ID = 'CHECK_BOX_INPUT_TEST_ID';
var Checkbox = forwardRef(function (props, ref) {
  var label = props.label,
      name = props.name,
      checked = props.checked,
      _props$defaultChecked = props.defaultChecked,
      defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked,
      onChange = props.onChange,
      className = props.className,
      disabled = props.disabled,
      _props$testId = props.testId,
      testId = _props$testId === void 0 ? CHECK_BOX_TEST_ID : _props$testId,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? false : _props$inline,
      isKomus = props.isKomus;
  var id = "checkbox_".concat(name);

  var _useState = useState(defaultChecked),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var controlled = typeof checked !== 'undefined';
  var finalValue = controlled ? checked : value;

  var handleChange = function handleChange(e) {
    if (!controlled) {
      setValue(!value);
    }

    onChange(e.currentTarget.checked);
  };

  return React.createElement(CheckBoxContainer, {
    "data-testid": testId,
    className: className,
    inline: inline
  }, React.createElement(Text, {
    size: 300
  }, React.createElement(CheckboxInput, _extends({
    "data-testid": CHECK_BOX_INPUT_TEST_ID,
    type: "checkbox",
    onChange: handleChange
  }, {
    name: name,
    disabled: disabled,
    id: id,
    ref: ref
  }, {
    checked: finalValue
  })), React.createElement(CheckboxLabel, {
    htmlFor: id
  }, React.createElement(CheckboxIcon, {
    isKomus: isKomus,
    checked: finalValue
  }, isKomus ? React.createElement(CheckIcon, {
    color: colors.dark300
  }) : React.createElement(CheckIcon, null)), label)));
});
Checkbox.displayName = 'Checkbox';
export default Checkbox;